// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuppliersSection_filter__FIzIP {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 1rem 0;
}

.SuppliersSection_input__Ftq8I {
  width: 20%;
  padding: 10px;
  margin-right: 1%;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;
  overflow: hidden;
}

.SuppliersSection_filters__select__C31Cu {
  width: 21%;
  margin-right: 1%;
}


.SuppliersSection_tableWrapper__l4pPX {
  max-height: 28vw; 
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.SuppliersSection_table__zRhAB {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}
.SuppliersSection_page__hvy0i {
  color: red;
}
.SuppliersSection_table__zRhAB th,
.SuppliersSection_table__zRhAB td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.SuppliersSection_table__zRhAB th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.SuppliersSection_table__zRhAB tr:hover {
  background-color: #f5f5f5;
}

.SuppliersSection_addSuppliers__EY-Hc {
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/styles/SuppliersSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".filter {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n.input {\n  width: 20%;\n  padding: 10px;\n  margin-right: 1%;\n  font-size: 14px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;\n  overflow: hidden;\n}\n\n.filters__select {\n  width: 21%;\n  margin-right: 1%;\n}\n\n\n.tableWrapper {\n  max-height: 28vw; \n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.addSuppliers {\n  position: absolute;\n  top: 2rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter": `SuppliersSection_filter__FIzIP`,
	"input": `SuppliersSection_input__Ftq8I`,
	"filters__select": `SuppliersSection_filters__select__C31Cu`,
	"tableWrapper": `SuppliersSection_tableWrapper__l4pPX`,
	"table": `SuppliersSection_table__zRhAB`,
	"page": `SuppliersSection_page__hvy0i`,
	"addSuppliers": `SuppliersSection_addSuppliers__EY-Hc`
};
export default ___CSS_LOADER_EXPORT___;
